import { defineMessages } from 'react-intl';

const scope = `app.containers.TipDirectPage`;

export default defineMessages({
  profile: {
    id: `${scope}.profile`,
    defaultMessage: 'Profile'
  },
  payments: {
    id: `${scope}.payments`,
    defaultMessage: 'Payments'
  },
  dashboard: {
    id: `${scope}.dashboard`,
    defaultMessage: 'Dashboard'
  },
  tipDirect: {
    id: `${scope}.tipDirect`,
    defaultMessage: 'Get Tips'
  },
  balance: {
    id: `${scope}.balance`,
    defaultMessage: 'Balance'
  },
  users: {
    id: `${scope}.users`,
    defaultMessage: 'Users'
  },
  transactions: {
    id: `${scope}.transactions`,
    defaultMessage: 'Transactions'
  },
  reviews: {
    id: `${scope}.reviews`,
    defaultMessage: 'Reviews'
  },
  resources: {
    id: `${scope}.resources`,
    defaultMessage: 'Resources'
  },
  admin: {
    id: `${scope}.admin`,
    defaultMessage: 'Admin'
  },
  tours: {
    id: `${scope}.tours`,
    defaultMessage: 'Tours'
  },
  settings: {
    id: `${scope}.settings`,
    defaultMessage: 'Settings'
  },
  recommend: {
    id: `${scope}.recommend`,
    defaultMessage: 'Recommend'
  },
  usToAFriend: {
    id: `${scope}.us_to_a_friend`,
    defaultMessage: 'Us to a friend'
  },
  recommendToAFriend: {
    id: `${scope}.recommend_to_a_friend`,
    defaultMessage: 'Recommend To A Friend'
  },
  upgradeButton: {
    id: `${scope}.upgrade_button`,
    defaultMessage: 'Upgrade to Pro'
  },
  companyInvite: {
    id: `${scope}.companyInvite`,
    defaultMessage: 'Company Invite'
  },
  upsell: {
    id: `${scope}.upsell`,
    defaultMessage: 'Upsell'
  },
  social: {
    id: `${scope}.social`,
    defaultMessage: 'Social'
  },
  branding: {
    id: `${scope}.branding`,
    defaultMessage: 'Branding'
  },
  customLink: {
    id: `${scope}.customLink`,
    defaultMessage: 'Custom Links'
  },
  setup: {
    id: `${scope}.setup`,
    defaultMessage: 'Setup'
  },
  commission: {
    id: `${scope}.commission`,
    defaultMessage: 'Commission'
  },
  takePayments: {
    id: `${scope}.takePayments`,
    defaultMessage: 'Take Payments'
  },
  messaging: {
    id: `${scope}.messaging`,
    defaultMessage: 'Messaging'
  },
  // Card 119, renamed by card 211 — labelled "FAQ" rather than "Learn" or
  // "Advice": guides look for this tab when they have a question, not when they
  // want a course. The tab id stays `Learn` because it doubles as the URL
  // segment (`/tipdirect/learn`), which the dashboard card deep-links into.
  learn: {
    id: `${scope}.learn`,
    defaultMessage: 'FAQ'
  },
  // Card 305 — guide-facing tour photo capture.
  tourPhotos: {
    id: `${scope}.tourPhotos`,
    defaultMessage: 'Tour Photos'
  },
  // Card 324 — head office's guest feedback page.
  guestFeedback: {
    id: `${scope}.guestFeedback`,
    defaultMessage: 'Guest Feedback'
  },
  // Card 323 — the guide's guest feedback QR.
  feedbackQr: {
    id: `${scope}.feedbackQr`,
    defaultMessage: 'Feedback QR'
  },
  // Card 288 — guest review replies and moderation. PROTOTYPE.
  guestReviews: {
    id: `${scope}.guestReviews`,
    defaultMessage: 'Guest Reviews'
  },
  productImprovement: {
    id: `${scope}.productImprovement`,
    defaultMessage: 'Product Improvement'
  },
  getReviews: {
    id: `${scope}.getReviews`,
    defaultMessage: 'Get Reviews'
  },
  stripe: {
    id: `${scope}.stripe`,
    defaultMessage: 'Stripe'
  }
});
